import type { SchemaBuilderGroupOptionItem } from "../../schema-builder.type";

import { normalizeForSearch } from "@/utilities/string";

export const filterConditionOptions = (
  optionsGroup?: SchemaBuilderGroupOptionItem[],
  search?: string
) => {
  if (!search || !optionsGroup?.length) return optionsGroup ?? [];

  const normalizedSearch = normalizeForSearch(search);

  // Filter options by search
  const options = optionsGroup.map((group) => ({
    label: group.label,
    options: (group.options ?? []).filter(({ label }) =>
      normalizeForSearch(label).includes(normalizedSearch)
    ),
  }));

  // Hide empty option groups
  return options.filter((group) => group.options.length > 0);
};
